/*
 * File: DateInput.tsx
 * Author: Austin Robinson
 * Date Created: 10/18/2023
 * Copyright (c) DrivingDoc 2023
 */
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker, DateTimePickerProps } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs, { Dayjs } from 'dayjs';
import { Controller, useFormContext } from 'react-hook-form';

interface PropTypes extends DateTimePickerProps<Dayjs> {
  name: string;
  label: string;
  helperText?: string;
}

export default function DateTimeInput({ name, label, helperText, ...props }: PropTypes) {
  const { control } = useFormContext();
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Controller
        control={control}
        name={name}
        render={({ field, fieldState }) => (
          <DateTimePicker
            label={label}
            slotProps={{
              textField: {
                variant: 'standard',
                fullWidth: true,
                InputLabelProps: { shrink: true },
                error: !!fieldState.error,
                helperText: fieldState.error ? fieldState.error?.message : helperText,
                onBlur: field.onBlur,
              },
            }}
            inputRef={field.ref}
            value={dayjs(field.value)}
            onChange={(newValue) => {
              // round to the start of the minute since it is the smallest unit
              field.onChange(dayjs(newValue).startOf('minute').toISOString());
            }}
            onError={(newError) => console.log(`Date Error: ${newError}`)}
            {...props}
          />
        )}
      />
    </LocalizationProvider>
  );
}
